import React from 'react'


function Contact(props){

  const headerStyle= {
    backgroundColor: "#012782"
  }

  const formStyle ={
    borderRadius: '3%',
    WebkitBoxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
    MozBoxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
    boxShadow: '4px 9px 12px 4px rgba(51,74,230,0.53)',
  
  
}

  return(
    <div className="container">
      <div className="row py-4 justify-content-center">
        <div className="col-10">
          <div className="card bg-light" style={formStyle}>

              <h5 className="card-header py-4 text-white text-center" style={headerStyle}>
                  <strong>Contact us</strong>
              </h5>
              <div className="card-body">
                  <form className="" action="">
                      <div className="md-form my-3">
                      <label> <strong>Name</strong></label><br/>
                      <input type="text" className="form-control"/>  
                      </div>

                      <div className="md-form my-3">
                        <label ><strong>Email</strong></label>
                        <input type="email"  className="form-control"/>
                      </div>

                      <span> <strong>Subject</strong></span><br/><br/>
                      <select className="mdb-select form-control">
                          <option value="" disabled>Choose option</option>
                          <option value="1" selected>Partnershhip</option>
                          <option value="2">Research project</option>
                          <option value="3">Internship</option>
                          <option value="4">Feedback</option>
                          <option value="4">Other</option>
                      </select>

                      <div className="md-form my-4">
                        <label> <strong>Message</strong> </label>
                        <textarea className="form-control md-textarea" rows="3"></textarea>
                          
                      </div>

                      <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"> <strong>Send me a copy of this message</strong> </label>
                      </div>

                      <button className="btn btn-outline-success btn-rounded  z-depth-0 my-4 waves-effect" type="submit">Send</button>

                  </form>

              </div>

          </div>
        </div>
      </div>
    </div>
    
  )
}


export default Contact